import React, {useState} from 'react'
import {InputAdornment, TextField} from '@material-ui/core';
import PropTypes from 'prop-types';
import {setSearchObj} from 'libs/RouterPath';
import querystring from 'querystring';
import WorkableIconSearchButton from "./button/WorkableIconSearchButton";

function SearchInput({
	className,
	label,
	id,
	handleSubmit
}) {
	const getInitValue = () => {
		const search = window.location.search;
		const value = querystring.parse(search.slice(1))[id];
		return value ? value : '';
	}

	const [value, setValue] = useState(getInitValue())

	const handleChange = (e) => {
		setValue(e.target.value)
	}

	const hadleClick = (e) => {
		if(handleSubmit) {
			handleSubmit({ [id]: value });
		} else {
			setSearchObj({ [id]: value })
		}
	}

	const handleKeyUp = (e) => {
		if (e.key === 'Enter') {
			hadleClick()
		}
	}

	return (
		<TextField
			className={className}
			label={label}
			onChange={handleChange}
			onKeyUp={handleKeyUp}
			fullWidth
			value={value}
			InputProps={{
				endAdornment: <InputAdornment position="end">
					<WorkableIconSearchButton
						onClick={hadleClick}
					/>
				</InputAdornment>,
			}}
		/>
	)
}

SearchInput.propTypes = {
	classes: PropTypes.any,
	className: PropTypes.string,
	label: PropTypes.string,
	id: PropTypes.string,
}

SearchInput.defaultProps = {
}

export default SearchInput;